import { render } from "./VendorDetailsServicesTab.vue?vue&type=template&id=462ab328"
import script from "./VendorDetailsServicesTab.vue?vue&type=script&lang=js"
export * from "./VendorDetailsServicesTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__